export default function sponsorConfirm() {
    let $ = jQuery;

    // Check if page template is sponsor-confirm
    const pageTemplate = document.querySelector('.page-template-wonder-contest-sponsor-confirm');

    if (!pageTemplate) {
        return;
    }

    // Check for id and name in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const sponsorId = urlParams.get('id');
    const sponsorEmail = urlParams.get('email');

    // If both parameters are not there redirec to the homepage
    if (!sponsorId || !sponsorEmail) {
        //window.location.href = '/';
    } else {
        $.ajax({
            url: menaObject.ajaxurl,
            type: 'POST',
            data: {
                action: 'confirm_sponsor',
                id: sponsorId,
                email: sponsorEmail,
            },
            success: function (response) {
                response = JSON.parse(response);
                let message;

                console.log(response);

                if (response.error == 'Invalid language') {
                    message = menaObject.wondercontestMessages.invalidLanguage;
                }
                if (response.error == 'Invalid sponsor') {
                    message = menaObject.wondercontestMessages.invalidSponsor;
                }
                if (response.error == 'Sponsor already confirmed') {
                    message = menaObject.wondercontestMessages.sponsorConfirmed;
                }
                if (response.error == 'Invalid participant') {
                    message = menaObject.wondercontestMessages.invalidParticipant;
                }
                if (response.error) {
                    const $notification = $('.wonder-contest__notification');
                    $notification.find('p').text(message);
                    $notification.addClass('visible');
                    //window.location.href = '/';
                } else {
                    pageTemplate.classList.add('active');
                }
            },
        });
    }
}
